import React from 'react';
import { AtualizaModeloInativoConsumer } from './AtualizaModeloInativoConsumer';

export const withAtualizaModeloInativo = Component => props => (
  <AtualizaModeloInativoConsumer>
    <Component {...props} />
  </AtualizaModeloInativoConsumer>
);
